module.exports = __webpack_public_path__ + "img/ic_64_achievement_welcome.0a9825a6.svg";